import { useQuery } from "@tanstack/react-query";
import { getAuthToken } from "../auth";
import { apiInstances, defaultQueryOptions } from "../config";

export const useUserInfo = () => {
  const token = getAuthToken();

  return useQuery({
    queryKey: ["userInfo"],
    queryFn: async () => {
      const response = await apiInstances.userApi.getUserInfo();
      return response.data;
    },
    enabled: !!token,
    gcTime: 10 * 60 * 1000,
    ...defaultQueryOptions,
  });
};

export const useUserBusinesses = () => {
  return useQuery({
    queryKey: ["userBusinesses"],
    queryFn: async () => {
      const response = await apiInstances.userApi.getUserBusiness();
      return response.data;
    },
    gcTime: 10 * 60 * 1000,
    ...defaultQueryOptions,
  });
};

export const useFilterableBusinesses = () => {
  return useQuery({
    queryKey: ["filterableBusinesses"],
    queryFn: async () => {
      const response = await apiInstances.userApi.getFilterableBusinesses();
      return response.data;
    },
    gcTime: 30 * 60 * 1000,
    ...defaultQueryOptions,
  });
};
